import { CompareCalculationsRouteView } from './view';
import { withCrumb } from '@/app/routing/breadcrumbs';

export const compareRoute = {
  path: 'compare',
  element: <CompareCalculationsRouteView/>,
  handle: () => withCrumb({
    element: () => <span>Compare Calculations</span>,
  })
};